import { View as RNView } from 'react-native'

import { styled, ViewProps } from '../../styled'

export const View = styled<ViewProps>(RNView, { style: 'view' })
